// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractSimpleModuleUi, abstractSimpleModuleUiOptions } from '../_abstract/ui';
/**
 * Component capable of rendering the `HeadingModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let HeadingModuleUi = class HeadingModuleUi extends AbstractSimpleModuleUi {
};
HeadingModuleUi = __decorate([
    Component({ ...abstractSimpleModuleUiOptions, name: 'HeadingModuleUi' })
], HeadingModuleUi);
export { HeadingModuleUi };
